<template>
  <transition
    name="toast-slide"
    appear>
    <div class="toast-call-tasks">
      <div class="toast-call-tasks__wrapper">
        <div class="toast-call-tasks__selected">
          {{ selectedTaskIds.length }} Tasks Selected:
        </div>
        <div
          class="toast-call-tasks__btn-start"
          @click="clickStart">
          <font-awesome-icon :icon="dataPhone" />
          <span>Start Auto Calls</span>
        </div>
        <div
          class="toast-call-tasks__btn-cancel"
          @click="clickCancel">
          <font-awesome-icon :icon="dataIconClose" />
          <span>Cancel</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { faPhone, faTimes } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'ToastCallTasks',
  props: {
    selectedTaskIds: {
      type: Array,
      default () {
        return [];
      }
    }
  },

  data () {
    return {
      dataPhone: faPhone,
      dataIconClose: faTimes
    };
  },

  methods: {
    clickStart () {
      this.$emit('on-start', this.selectedTaskIds);
    },
    clickCancel () {
      this.$emit('on-cancel');
    }
  }
};
</script>

<style lang="scss" scoped>
.toast-call-tasks {
  position: fixed;
  z-index: 10;
  bottom: 100px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
  border: solid 1px #20a052;
  background-color: #e8f5ed;

  &__wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }

  &__selected {
    font-size: 14px;
    font-weight: 600;
    color: #222;
  }
  &__btn-start {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 600;
    color: #20a052;
    cursor: pointer;
  }

  &__btn-cancel {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 600;
    color: #dd2f43;
    cursor: pointer;
  }
}

.toast-slide-enter-active,
.toast-slide-leave-active {
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;
}

.toast-slide-enter,
.toast-slide-leave-to {
  opacity: 0;
  transform: translate(-50%, 40px);
}

.toast-slide-enter-to,
.toast-slide-leave {
  opacity: 1;
  transform: translate(-50%, 0);
}
</style>
